export class CompleteSurveyDto {
  surveyId: string;
  surveyStatus: number;

  constructor(data: { surveyId: string }) {
    this.surveyId = data.surveyId;
  }
}
